import React, { useEffect, useState } from "react";
import { useTalentos } from "./hooks/useTalentos";
import { connect } from "react-redux";


import ValidateToken from "components/ValidToken";
import Spinner from "react-bootstrap/Spinner";
import ToggleDetail from "components/ToggleDetail";
import TalentoDetalle from "./components/TalentoDetalle";
import TalentoForm from "./components/TalentoForm";

const TalentosModule = ({ user }) => {
  const {
    fetchTalentosModuleData,
    isLoading,
    showDetail,
    talentos,
    setShowDetail,
  } = useTalentos(user);

  useEffect(() => {
    (async function mounted() {
      await fetchTalentosModuleData();
    })();
  }, []);

  return (
    <>
      <ValidateToken />
      <div className={""}>
        {isLoading && (
          <div className={"display-flex flex-direction-row flex-center"}>
            <Spinner
              animation="grow"
              variant="primary"
              className={"is-absolute center-spinner-vertically"}
              size="lg"
            />
          </div>
        )}
        <ToggleDetail
          initState={showDetail}
          onToggleDetail={setShowDetail}
          label="Talentos"
        />
        {showDetail ? <TalentoDetalle user={user} /> : <TalentoForm personaTalentos={user.persona.personaTalentos} talentos={talentos} />}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(TalentosModule);
